// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import Search from "@insite/mobius/Icons/Search";
import { searchBoxStyles } from "@steiner/Overrides/Widgets/MyLists/MyListsSearchBox";
import { color, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

searchBoxStyles.search = {
    mergeCss: true,
    labelPosition: "top",
    label: translate("Product Group Name or Tag"),
    cssOverrides: {
        formInputWrapper: css`
            width: 316px;
            ${xScreen("lte", "md")} {
                width: 100%;
            }
        `,
    },
    iconProps: {
        src: Search,
        color: "primary",
        size: 15,
        mergeCss: true,
        css: css`
            &&& {
                right: 7px;
                padding: 0 0 0 6px;
            }
        `,
    },
};

searchBoxStyles.clearIcon = {
    size: 16,
    color: "common.ui1",
    css: css`
        top: 35px;
        right: 42px;
        border-radius: 50%;
        background: ${color("primary")};
        padding: 2px;
        cursor: pointer;
        position: absolute;
    `,
};

searchBoxStyles.wrapper = {
    css: css`
        position: relative;

        &&&&& input {
            padding-right: 70px;
        }
    `,
}